<template>
  <div class="sign-main">
    <div class="sign-control">
      <div class="sign-btn" v-if="!base64" @click="showModal = true">开始签名</div>
      <template v-if="base64">
        <div class="sign-preview" @click="showPreview = true">
          <img :src="base64" alt="">
        </div>
        <span @click="clearSign" class="iconfont icon-icon1460188478041"></span>
      </template>
    </div>
    <div class="signModal" v-if="showModal">
      <div class="signModal-mask"></div>
      <div class="signModal-container">
        <h2 class="title">
          电子签名板
          <span class="iconfont icon-cuowu" @click="showModal = false"></span>
        </h2>
        <sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value"/>
        <div class="sign-btns">
          <span class="btn" @click="canvasClear()">清空</span>
          <span class="btn" @click="saveSignPicture()">保存</span>
        </div>
      </div>
    </div>
    <div class="signModal" v-if="showPreview">
      <div class="signModal-mask"></div>
      <div class="signModal-container">
        <h2 class="title">
          预览
          <span class="iconfont icon-cuowu" @click="showPreview = false"></span>
        </h2>
        <img :src="base64" style="margin: 15px 0;width: 100%;height: auto" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    masterId: '',
  },
  data() {
    var tempWidth = 300;
    if(document.documentElement && document.documentElement.clientWidth){
      tempWidth = document.documentElement.clientWidth * 0.8
    }
    return {
      showModal: false,
      showPreview: false,
      base64: '',
      value: null,
      options: {
        isDpr: true, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: "bevel", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: tempWidth, //canvas宽高 [Number] 可选
        canvasHeight: tempWidth, //高度  [Number] 可选
        isShowBorder: true, //是否显示边框 [可选]
        bgColor: "#eee", //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#ccc", //网格颜色  [String] 可选
        writeWidth: 2, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
    };
  },
  mounted() {
    if (this.masterId) {
      this.findSignPicture()
    }
  },
  methods: {
    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },
    clearSign() {
      var self = this
      this.confirm2('确定要删除签名吗', action => {
        self.saveSignPicture('clear')
      })
    },
    /**
     * 保存图片
     */
    saveSignPicture(type) {
      var str = ''
      var successMsg = ''
      if (type == 'clear') {
        str = ''
        successMsg = '签名清空成功'
      } else {
        const img = this.$refs.SignCanvas.saveAsImg();
        str = img.split(',')[1]
        successMsg = '签名保存成功'
      }
      this.$http.post('/mobilepmsapi/reception/saveSignPicture', {
        scanPic: str,
        masterId: this.masterId, // 544
      }).then(res => {
        if(res.data.result == 0){
          this.msg2(successMsg)
          this.findSignPicture()
          this.showModal = false
        } else {
          this.msg2(res.data.msg);
        }
      });
    },
    findSignPicture() {
      this.$http.post('/mobilepmsapi/reception/findSignPicture', {
        masterId: this.masterId,
      }).then(res => {
        if (res.data.result == 0 ) {
          if(res.data.retVal.scanPic){
            this.base64 = 'data:image/png;base64,' + res.data.retVal.scanPic
          } else {
            this.base64 = ''
          }
        } else {
          this.base64 = ''
        }
      });
    },
    /**
     * 下载图片
     */
    downloadSignImg() {
      this.$refs.SignCanvas.downloadSignImg();
    },
  },
};
</script>

<style lang="less">
.sign-main {
  padding: 15px;
  box-sizing: border-box;
  display: inline-block;

  .sign-control {
    display: flex;
    align-items: center;

    .iconfont {
      font-size: 25px;
      margin-left: 15px;
      color: #999;
    }
  }

  .sign-btn {
    display: inline-block;
    padding: 0 15px;
    height: 26px;
    line-height: 26px;
    box-sizing: border-box;
    border-radius: 4px;
    background: #ffa500;
    color: #fff;
    margin-right: 15px;
  }

  .sign-preview {
    display: inline-block;

    img {
      display: inline-block;
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #ccc;
    }
  }

  .signModal {
    .signModal-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      background: rgba(0, 0, 0, 0.5);
    }

    .signModal-container {
      background: #fff;
      width: 90%;
      overflow: hidden;
      border-radius: 10px;
      position: fixed;
      top: 50%;
      left: 50%;
      padding-bottom: 15px;
      transform: translate(-50%, -50%);
      z-index: 11;

      .title {
        padding-top: 20px;
        font-size: 16px;
        text-align: center;
        position: relative;

        .icon-cuowu {
          position: absolute;
          right: 20px;
          color: #999;
        }
      }

      .sign-canvas {
        display: block;
        margin: 20px auto;
      }

      .view-image {
        display: block;
        margin: 20px auto;
      }

      .config {
        width: 350px;
        margin: 20px auto;

        .ul-config {
          .li-c {
            display: flex;
            align-items: center;
            padding: 4px 10px;

            .item-label {
              font-size: 14px;
            }

            .item-content {
              margin-left: 10px;
            }
          }
        }
      }

      .sign-btns {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;

        .btn {
          display: inline-block;
          width: 40%;
          padding: 15px 0;
          border: 1px solid #eee;
          background: #e1e1e1;
          border-radius: 10px;
          text-align: center;
          cursor: pointer;
        }
      }

      .aversion {
        .title {
          text-align: center;
          margin-top: 10px;

          h1 {
            margin: 20px auto 5px;
            font-size: 0.5rem;
          }

          h2 {
            font-size: 0.3rem;
            font-weight: normal;
            margin-top: 0;
            color: #999;
          }

          img {
            width: 54px;
            margin: 0 auto 5px;
          }
        }

        .tip {
          margin: 0 auto;
          width: 90%;
        }

        .tip li {
          line-height: 0.5rem;
          margin-top: 5px;
        }

        .tip .pic img {
          width: 80%;
          margin: 0 auto;
        }

        .ver {
          position: fixed;
          bottom: 10px;
          left: 0;
          width: 100%;
          text-align: center;

          img {
            width: 63px;
            height: 18px;
            margin: 0 auto;
          }

          div {
            font-size: 9px;
            color: #d7d7d7;
            margin-top: 8px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// signModal.vue?52e34394